<template>
    <div id="workWithUs">
        <for-all-modes-from-here 
            :thoseModalName="modalName" 
            :monthlyInvoicingString="qtdeFaturamento"
            :qtdeFaturamento8="qtdeFaturamento8"
            :qtdeFaturamento8Year="qtdeFaturamento8Year"
            :qtdeFaturamento10="qtdeFaturamento10"
            :qtdeFaturamento10Year="qtdeFaturamento10Year"
            :lostCustomersMIN="lostCustomersMIN"
            :lostCustomersMAX="lostCustomersMAX"
            :billingGainMIN="billingGainMIN"
            :billingGainMAX="billingGainMAX"
            :stopWinningMIN="stopWinningMIN"
            :stopWinningMAX="stopWinningMAX"
            :stopWinningMIN_ANO="stopWinningMIN_ANO"
            :stopWinningMAX_ANO="stopWinningMAX_ANO"
        />
        <div class="img-topo d-flex align-items-center">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-8 offset-md-2">
                        <div>
                            <h1 class="color-white big-title f-w-700 text-center">Quanto estou perdendo na minha lotérica?</h1>
                        </div>    
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row py-2 color-white">
                <div class="col-12 col-md-5 text-center text-md-left">
                    <h2 class="mb-4">Calcule quanto em média você deixa de faturar mensalmente na sua lotérica.</h2>
                    Talvez você nunca parou para pensar: <br>
                    - Quanto estou perdendo($) na minha lotérica? <br>
                    - Quanto os clientes gastariam se eu tivesse mais serviços pra oferecer? <br>
                    - Se minha lotérica tivesse um Ponto Fácil, quantos clientes novos eu ganharia?
                    <br><br>
                    <strong>Preencha os campos e descubra a Franquia que pode transformar os seus resultados!</strong>
                    <hr>
                </div>
                <div class="col-12 col-md-7">
                    <form action="">
                        <label>Qual a quantidade de caixas na lotérica?</label>
                        <input required type="text" placeholder="Quantidade" v-model="qtdeLotteryBox">
                        <label>Qual é o faturamento médio mensal da lotérica com recebimento de contas (SITAE)?</label>
                        <input required type="text" class="mb-3" :placeholder="`R$ ${price}`" v-model="MonthlyInvoicing" v-money="money">
                        <div @click="textPreparedToCalc()" class="text-center bg">
                            <span id="Btn-send">{{StatusSendding}}</span>
                        </div>
                        <hr>
                        <p class="text-center text-md-left">
                            <strong>Atenção:</strong><br> Nós <strong>NÃO</strong> solicitamos nenhum dado pessoal, esta pesquisa é gratuita e baseada em dados <strong>REAIS</strong> obtidos em mais de 5 anos de experiência com as franquias Ponto Fácil nas casas lotéricas. 
                        </p>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    *{
        transition-duration: 0;
        transition-timing-function: ease-in;
    }
    .img-topo {
        background-image: url("../assets/howmuch/img-topo.png");
        background-size: cover;
        background-position: 0 -80px;
        height: 300px;
    } 
    
    span{
        width: 100%!important;
    }
    
    h2{
        line-height: 1.25!important
    }     
    .selectinfVacancy{
        padding: 8px 25px;
        border-radius: 10px;
        font-size: 12px;
    }

    input[type="text"], input[type="email"] {
        background-color: #fff;
        width: 100%;
        height: 50px;
        margin: 0 0 15px 0;
        padding-left: 15px;
        text-align: left;
        border-radius: 10px;
    }

    input::placeholder{
        text-align: left;
    }

    .fileName{
        font-size: 10px;
    }

    .sharing{
        padding:8px 40px;
        border-radius: 10px;
        box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, .15);
        color: #175D93;
        font-size: 14px;
        margin: 5px 0;
    }


    .sharing:hover{
        background-color: rgba(23, 93, 147,75);
        color: rgba(255, 255, 255, .8);
        cursor: pointer;
    }

    #btn-send{
        background-color: transparent!important;
        -webkit-appearance: caret!important
    }

    .bg:hover{
        background-color: rgba(3, 73, 127);
        cursor: pointer;
    }    

    .colCursor .target{
        padding: 15px 20px;        
    }

    .colCursor{
        background-color: #fff;
        margin: 15px 0;
        border-radius: 10px;
    }

    .colCursor h2{
        font-size: 14px;
        margin: 0;
        color: rgb(173, 173, 173);
    }

    .colCursor :hover{
        cursor: pointer;
    }

    .rotate{
        transform: rotateZ(180deg)
    }

    #workWithUs{
        /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#e0a638+1,f38235+100 */
        background: #e0a638; /* Old browsers */
        background: -moz-linear-gradient(45deg,  #e0a638 1%, #f38235 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(45deg,  #e0a638 1%,#f38235 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(45deg,  #e0a638 1%,#f38235 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0a638', endColorstr='#f38235',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
        padding-top: 100px;
    }

    h1{
        margin-bottom: 30px;
    }

    h3{
        font-size: 20px;
        padding: 15px 0;
    }
    p {
        line-height: 22px;
    }
    .colCursor p{
        max-width: 100%;
        font-size: 12px;
        color: rgb(173, 173, 173);
        padding: 15px 20px 5px 20px;
        margin: 0
    }

    .anchoring{
        margin-top: 10px;
        padding: 10px 0 30px 20px;
    }

     label{
        font-size: 12px;
        top: -25px!important;
        color: #fff;
        font-weight: 700;
    }
    
    .first-camp{
        border-top: 2px solid rgba(255, 255, 255, 0.4);
        border-bottom: 2px solid rgba(255, 255, 255, 0.4);
        margin-bottom: 50px;
        padding: 20px 0;
    }

    .radiosCamp label{
        font-weight: normal;
        font-size: 14px;
        margin: 0 25px 0 5px
    }

    .bg{
        background-color: rgb(23, 93, 147);
        padding: 15px 50px;
        font-size: 14px;
        border-radius: 10px;
    }

    .radiosCamp{
        margin-bottom: 30px;
    }

    .radiosCamp > div{
        margin-top: 25px;
    }
    

    input[type=radio] {
        width: 25px;
        height: 25px;
    }

    p.toDescriptions{
        font-size: 16px;
    }

    @media only screen and (max-width: 992px){
        .in-992{
            text-align: center;
        }

        #img_1 img{
            width: 100%;
        }
    }

    @media only screen and (max-width: 767px){
        p.toDescriptions{
            margin-right: 0px;
            text-align: center
        }
    }

</style>

<script>
import $ from 'jquery'
import {Money} from 'v-money'
import forAllModesFromHere from '@/components/modal/forAllModesFromHere'

export default {
    data() {
        return {
            qtdeLotteryBox: 0,
            qtdeFaturamento:0,
            qtdeFaturamento8:0,
            qtdeFaturamento8Year:0,
            qtdeFaturamento10:0,
            qtdeFaturamento10Year:0,
            lostCustomersMIN:0,
            lostCustomersMAX:0,
            billingGainMIN:0,
            billingGainMAX:0,
            MonthlyInvoicing: 0,
            stopWinningMAX:0,
            stopWinningMIN:0,
            stopWinningMAX_ANO:0,
            stopWinningMIN_ANO:0,
            price: 100000,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
                masked: false
            },

            modalName: 'modalHowMuch',
            StatusSendding:"Calcular",
            // svgSending: false,
        }
    },
    components:{
        Money,
        forAllModesFromHere
    },
    methods: {
        textPreparedToCalc(){
            if (this.MonthlyInvoicing == 'R$ 0,00') {
                this.$alert("Insira o seu faturamento médio mensal da lotérica com recebimento de contas")
            }
            else{
                let t = this.MonthlyInvoicing.replace(/([^\d])+/gim, '');
                let u = t.length
                let v = t.substr(0, u-2)

                this.qtdeFaturamento = this.MonthlyInvoicing
                
                this.qtdeFaturamento8 = v * 4/100
                this.qtdeFaturamento10 = v * 8/100

                if (v < 15000) {
                    this.lostCustomersMIN = 800
                    this.lostCustomersMAX = 1300
                    this.billingGainMIN = 3000
                    this.billingGainMAX = 6000
                }
                else if(v <= 24999){
                    this.lostCustomersMIN = 1000
                    this.lostCustomersMAX = 1700
                    this.billingGainMIN = 5000
                    this.billingGainMAX = 8000
                }
                else if(v <= 29999){
                    this.lostCustomersMIN = 1400
                    this.lostCustomersMAX = 2100
                    this.billingGainMIN = 7000
                    this.billingGainMAX = 11000
                }
                else if (v >= 30000) {
                    this.lostCustomersMIN = 1800
                    this.lostCustomersMAX = 2900
                    this.billingGainMIN = 10000
                    this.billingGainMAX = 15000
                }
                this.stoppingWinning()
                this.showModal(this.modalName)
            }
        },
        stoppingWinning(){
            this.stopWinningMIN = parseFloat(this.qtdeFaturamento8+this.billingGainMIN).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
            this.stopWinningMAX = parseFloat(this.qtdeFaturamento10+this.billingGainMAX).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
            this.stopWinningMIN_ANO = parseFloat((this.qtdeFaturamento8+this.billingGainMIN)*12).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
            this.stopWinningMAX_ANO = parseFloat((this.qtdeFaturamento10+this.billingGainMAX)*12).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});

            this.qtdeFaturamento8Year = (this.qtdeFaturamento8 * 12).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
            this.qtdeFaturamento10Year = (this.qtdeFaturamento10 * 12).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});

            this.billingGainMIN = this.billingGainMIN.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
            this.billingGainMAX = this.billingGainMAX.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});



            this.qtdeFaturamento8 = this.qtdeFaturamento8.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
            this.qtdeFaturamento10 = this.qtdeFaturamento10.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
        }
    },  
    
}
</script>